import { createGlobalStyle } from 'styled-components'

import theme from '@/theme/theme'

const GlobalStyle = createGlobalStyle`
  strong {
    font-weight: ${theme.fontWeights.loudBold};
  }
  body{
    position: relative;
  } 
`

export default GlobalStyle
